import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import persistStore from 'redux-persist/es/persistStore';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { userAuthApi } from './apis/authApi';
import { holidayApi } from './apis/holidayApi';
import { leaveTypeApi } from './apis/LeaveType';
import { leaveRequestApi } from './apis/LeaveRequest';
import { departMentApi } from './apis/department';
import { employeeApi } from './apis/employee';
import { designationApi } from './apis/Designation';
import { leaveBalanceApi } from './apis/LeaveBalance';
import { attendanceApi } from './apis/attendanceApi';
import { filesApi } from './apis/files';
import { payrollApi } from './apis/payrollApi';

import { userAuth } from './Slice/userAuth';
import { timeTrackingApi } from './apis/timeTrackingApi';
import { supportTicketApi } from './apis/SupportTicketApi';
import { assetsApi } from './apis/AssetsApi';
import { assetFieldsApi } from './apis/AssetFieldsApi';
import { dashboardApi } from './apis/Dashboard';
import { calendarApi } from './apis/CalendarApi';
import { kpiApi } from './apis/KPIApi';
import { kpiReducer } from './Slice/kpiSlice';
import { performanceReducer } from './Slice/performanceSlice';
import { performanceApi } from './apis/PerformanceApi';
import { notificationApi } from './apis/Notification';
import { payrunReducer } from './Slice/payrunSlice';
import { lopAndOvertimeRequestApi } from './apis/LOPAndOvertimeAPI';
import { lopOvertimeRequestReducer } from './Slice/lopOvertimeRequestSlice';
import { complainApi } from './apis/ComplainApi';
import { contactUsApi } from './apis/ContactUsApi';
import { conferenceRoomApi } from './apis/ConferenceRoomApi';
import { hrxAttendanceReducer } from './Slice/hrxAttendanceSlice';
import { systemRoleApi } from './apis/systemRoleApi';
import { hrxModuleApi } from './apis/HrxModuleApi';
import { googleCalendarApi } from './apis/googleCalendarApi';
import { attendanceViolationApi } from './apis/attendanceViolationApi';
import { officeReducer } from './Slice/officeSlice';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [dashboardApi.reducerPath]
};

const rootReducer = combineReducers({
  [holidayApi.reducerPath]: holidayApi.reducer,
  [userAuthApi.reducerPath]: userAuthApi.reducer,
  [leaveTypeApi.reducerPath]: leaveTypeApi.reducer,
  [leaveRequestApi.reducerPath]: leaveRequestApi.reducer,
  [leaveBalanceApi.reducerPath]: leaveBalanceApi.reducer,
  [assetsApi.reducerPath]: assetsApi.reducer,
  [assetFieldsApi.reducerPath]: assetFieldsApi.reducer,
  [departMentApi.reducerPath]: departMentApi.reducer,
  [employeeApi.reducerPath]: employeeApi.reducer,
  [designationApi.reducerPath]: designationApi.reducer,
  [attendanceApi.reducerPath]: attendanceApi.reducer,
  [timeTrackingApi.reducerPath]: timeTrackingApi.reducer,
  [filesApi.reducerPath]: filesApi.reducer,
  auth: userAuth.reducer,
  office: officeReducer,
  [payrollApi.reducerPath]: payrollApi.reducer,
  [supportTicketApi.reducerPath]: supportTicketApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [calendarApi.reducerPath]: calendarApi.reducer,
  [kpiApi.reducerPath]: kpiApi.reducer,
  kpi: kpiReducer,
  performance: performanceReducer,
  [performanceApi.reducerPath]: performanceApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [complainApi.reducerPath]: complainApi.reducer,
  [contactUsApi.reducerPath]: contactUsApi.reducer,
  [conferenceRoomApi.reducerPath]: conferenceRoomApi.reducer,
  payrun: payrunReducer,
  [lopAndOvertimeRequestApi.reducerPath]: lopAndOvertimeRequestApi.reducer,
  lopOvertimeRequest: lopOvertimeRequestReducer,
  hrxAttendance: hrxAttendanceReducer,
  [systemRoleApi.reducerPath]: systemRoleApi.reducer,
  [hrxModuleApi.reducerPath]: hrxModuleApi.reducer,
  [googleCalendarApi.reducerPath]: googleCalendarApi.reducer,
  [attendanceViolationApi.reducerPath]: attendanceViolationApi.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // optional: ignore paths in state if needed
        ignoredPaths: ['register', 'rehydrate']
      }
    }).concat(
      holidayApi.middleware,
      attendanceApi.middleware,
      timeTrackingApi.middleware,
      departMentApi.middleware,
      userAuthApi.middleware,
      leaveTypeApi.middleware,
      employeeApi.middleware,
      designationApi.middleware,
      leaveRequestApi.middleware,
      leaveBalanceApi.middleware,
      filesApi.middleware,
      payrollApi.middleware,
      supportTicketApi.middleware,
      assetsApi.middleware,
      assetFieldsApi.middleware,
      dashboardApi.middleware,
      calendarApi.middleware,
      kpiApi.middleware,
      performanceApi.middleware,
      notificationApi.middleware,
      lopAndOvertimeRequestApi.middleware,
      complainApi.middleware,
      contactUsApi.middleware,
      conferenceRoomApi.middleware,
      systemRoleApi.middleware,
      hrxModuleApi.middleware,
      googleCalendarApi.middleware,
      attendanceViolationApi.middleware
    )
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import persistStore from 'redux-persist/es/persistStore';
// import { combineReducers, configureStore } from '@reduxjs/toolkit';

// import { userAuthApi } from './apis/authApi';
// import { holidayApi } from './apis/holidayApi';
// import { leaveTypeApi } from './apis/LeaveType';
// import { leaveRequestApi } from './apis/LeaveRequest';
// import { departMentApi } from './apis/department';
// import { employeeApi } from './apis/employee';
// import { designationApi } from './apis/Designation';
// import { leaveBalanceApi } from './apis/LeaveBalance';
// import { attendanceApi } from './apis/attendanceApi';
// import { filesApi } from './apis/files';
// import { payrollApi } from './apis/payrollApi';

// import { userAuth } from './Slice/userAuth';
// import { timeTrackingApi } from './apis/timeTrackingApi';
// import { supportTicketApi } from './apis/SupportTicketApi';
// import { assetsApi } from './apis/AssetsApi';
// import { dashboardApi } from './apis/Dashboard';
// import { calendarApi } from './apis/CalendarApi';
// import { kpiApi } from './apis/KPIApi';
// import { kpiReducer } from './Slice/kpiSlice';
// import { performanceReducer } from './Slice/performanceSlice';
// import { performanceApi } from './apis/PerformanceApi';
// import { notificationApi } from './apis/Notification';
// import { payrunReducer } from './Slice/payrunSlice';
// import { lopAndOvertimeRequestApi } from './apis/LOPAndOvertimeAPI';
// import { lopOvertimeRequestReducer } from './Slice/lopOvertimeRequestSlice';
// import { complainApi } from './apis/ComplainApi';
// import { hrxAttendanceReducer } from './Slice/hrxAttendanceSlice';

// const persistConfig = {
//   key: 'root',
//   storage
// };

// const rootReducer = combineReducers({
//   [holidayApi.reducerPath]: holidayApi.reducer,
//   [userAuthApi.reducerPath]: userAuthApi.reducer,
//   [leaveTypeApi.reducerPath]: leaveTypeApi.reducer,
//   [leaveRequestApi.reducerPath]: leaveRequestApi.reducer,
//   [leaveBalanceApi.reducerPath]: leaveBalanceApi.reducer,
//   [assetsApi.reducerPath]: assetsApi.reducer,
//   [departMentApi.reducerPath]: departMentApi.reducer,
//   [employeeApi.reducerPath]: employeeApi.reducer,
//   [designationApi.reducerPath]: designationApi.reducer,
//   [attendanceApi.reducerPath]: attendanceApi.reducer,
//   [timeTrackingApi.reducerPath]: timeTrackingApi.reducer,
//   [filesApi.reducerPath]: filesApi.reducer,
//   auth: userAuth.reducer,
//   [payrollApi.reducerPath]: payrollApi.reducer,
//   [supportTicketApi.reducerPath]: supportTicketApi.reducer,
//   [dashboardApi.reducerPath]: dashboardApi.reducer,
//   [calendarApi.reducerPath]: calendarApi.reducer,
//   [kpiApi.reducerPath]: kpiApi.reducer,
//   kpi: kpiReducer,
//   performance: performanceReducer,
//   [performanceApi.reducerPath]: performanceApi.reducer,
//   [notificationApi.reducerPath]: notificationApi.reducer,
//   [complainApi.reducerPath]: complainApi.reducer,
//   payrun: payrunReducer,
//   [lopAndOvertimeRequestApi.reducerPath]: lopAndOvertimeRequestApi.reducer,
//   lopOvertimeRequest: lopOvertimeRequestReducer,
//   hrxAttendance: hrxAttendanceReducer
// });

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,

//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().concat(
//       holidayApi.middleware,
//       attendanceApi.middleware,
//       timeTrackingApi.middleware,
//       departMentApi.middleware,
//       userAuthApi.middleware,
//       leaveTypeApi.middleware,
//       employeeApi.middleware,
//       designationApi.middleware,
//       leaveRequestApi.middleware,
//       leaveBalanceApi.middleware,
//       filesApi.middleware,
//       payrollApi.middleware,
//       supportTicketApi.middleware,
//       assetsApi.middleware,
//       dashboardApi.middleware,
//       calendarApi.middleware,
//       kpiApi.middleware,
//       performanceApi.middleware,
//       notificationApi.middleware,
//       lopAndOvertimeRequestApi.middleware,
//       complainApi.middleware,
//       attendanceApi.middleware
//     )
// });

// export const persistor = persistStore(store);
